/**
 * The parts of the missing-address notice both sides need to agree on.
 *
 * `missing-address-notice.ts` imports Prisma, so a client component that only
 * wants to know "is this the address notice?" cannot import it — the whole
 * client bundle would pull the database in behind that one string. The drawer
 * needs the category to decide whether a click is the `seller_address` funnel's
 * middle step, so the constant lives here and the server module re-exports it.
 *
 * One definition, because two would fail silently: a drifted category does not
 * throw, it just makes the funnel's click step read zero forever while the
 * notice carries on working.
 */

/** Tags the notice inside NOTIFICATIONS.metadata so it can be found again. */
export const MISSING_ADDRESS_CATEGORY = 'missing-address';

export const MISSING_ADDRESS_ACTION_URL = '/account/addresses';
